import { render, staticRenderFns } from "./tableDynamic.vue?vue&type=template&id=31cff28c"
import script from "./tableDynamic.vue?vue&type=script&lang=js"
export * from "./tableDynamic.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports